<template>
  <div>
    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-if="!loading" :striped="false">
      <template v-slot:header>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Info</th>
          <th>Last Modified</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="item in pendingItemList" :key="`${item.linkId}-${item.linkType}`">
          <template v-if="item.linkType == LinkTypes.order">
            <td><LinkOrder :id="item.linkId" :name="`Order #${item.sequenceNumber}`" :newTab="false" /></td>
            <td>
              <LabelBadge :labelClass="`label-order-status-${item.status}`">{{item.status | formatLookupName(OrderStatusTypeLookup)}}</LabelBadge>
              <LabelBadge labelClass="label-order-hold ml-1" v-if="item.isOnHold">Hold</LabelBadge>
            </td>
            <td>{{item.info}}</td>
            <td>{{item.updatedAt | formatDate}}</td>
          </template>

          <template v-if="item.linkType == LinkTypes.purchaseOrder">
            <td><LinkPurchaseOrder :id="item.linkId" :name="`Purchase Order #${item.sequenceNumber}`" :newTab="false" /></td>
            <td>
              <LabelBadge :labelClass="`label-po-status-${item.status}`">{{item.status | formatLookupName(PurchaseOrderStatusTypeLookup)}}</LabelBadge>
            </td>
            <td>{{item.info}}</td>
            <td>{{item.updatedAt | formatDate}}</td>
          </template>

          <template v-if="item.linkType == LinkTypes.stockPriceRequestGroup">
            <td><LinkPriceRequest :id="item.linkId" :name="`Price Request #${item.sequenceNumber}`" :newTab="false" /></td>
            <td>
              <LabelPriceRequestStatusBadge :status="item.status" />
            </td>
            <td>{{item.info}}</td>
            <td>{{item.updatedAt | formatDate}}</td>
          </template>
        </tr>
      </template>
    </StaticDataTable>
  </div>
</template>

<script>
import StaticDataTable from '@/components/table/staticDataTable'
import LabelPriceRequestStatusBadge from '@/modules/pricing/components/labelPriceRequestStatusBadge'

import { LinkTypes, OrderStatusTypeLookup, PurchaseOrderStatusTypeLookup } from '@/store/types'

export default {
  name: 'PendingItemsList',
  components: {
    StaticDataTable,
    LabelPriceRequestStatusBadge
  },
  data() {
    return {
      loading: true,
      pendingItemList: []
    }
  },
  created() {
    this.LinkTypes = LinkTypes
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
    this.PurchaseOrderStatusTypeLookup = PurchaseOrderStatusTypeLookup
  },
  mounted() {
    this.requestData()

    // Subscribe to all relevant endpoints
    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      this.loading = true

      this.$apiService.coreService.getDashboardPendingItemList()
      .then(response => {
        this.pendingItemList = response.data
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>